/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseTemplateStar1Fragment} from '@amblique/contentful/app/contentful/fragments/template-star1/base-template-star1.fragment';

export const TemplateStar1Fragment = gql`
  ${BaseTemplateStar1Fragment}

  fragment TemplateStar1Fragment on TemplateStar1 {
    ...BaseTemplateStar1Fragment
  }
`;
